import React, { createContext } from 'react';

const ItemContext = createContext({});

export { ItemContext };